import React from 'react'
import { Box } from '../Styled'
import { Button } from 'lib/ui/components'
import { useHistory } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

export const ShareStory = () => {
  const history = useHistory()
  return (
    <Box className='shareStory'>
      <h2><FormattedMessage id='customer.account.dashboard.story.title' /></h2>
      <p><FormattedMessage id='customer.account.dashboard.story.p' /></p>
      <Button onClick={() => history.push('/customer/account/create')}>
        <FormattedMessage id='customer.account.dashboard.submit.story' />
      </Button>
    </Box>
  )
}
